import _isObjectLike from "lodash/isObjectLike";
import _camelCase from "lodash/camelCase";
import _set from "lodash/set";
import _transform from "lodash/transform";
import _isPlainObject from "lodash/isPlainObject";
import _map from "lodash/map";
import _isArray from "lodash/isArray";

var camelCaseKeys = function camelCaseKeys(node) {
  if (_isArray(node)) {
    return _map(node, camelCaseKeys);
  }

  if (_isPlainObject(node)) {
    return _transform(node, function (result, value, key) {
      return _set(result, _camelCase(key), _isObjectLike(value) ? camelCaseKeys(value) : value);
    });
  }

  return node;
};

export default camelCaseKeys;
//# sourceMappingURL=camelCase.js.map